"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./RatingChart.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The RatingChart component is used to show buy/sell statistic data
 */
const RatingChart = /*#__PURE__*/React.forwardRef(({
  buyValue,
  sellValue,
  width = 'inline',
  description = '',
  averageLabel = '',
  buyLabel = '',
  sellLabel = '',
  indicators,
  ...otherProps
}, ref) => {
  const percent = buyValue !== undefined && sellValue !== undefined ? buyValue / (buyValue + sellValue) * 100 : null;
  const isBuyWin = percent && percent > 50;
  return (0, _pragma.createFelaElement)(_.Card, _extends({
    width: width,
    css: css.wrapper,
    variant: "secondary",
    color: "tan",
    ref: ref
  }, otherProps), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    padding: ['xlarge', 'medium'],
    flex: true
  }, (0, _pragma.createFelaElement)(_.View, {
    flex: true,
    flexDirection: "row",
    margin: [0, 0, 'xlarge', 0]
  }, (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    margin: [0, 'xlarge', 0, 0],
    css: css.indicator
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: "text.2"
  }, averageLabel), percent ? (0, _pragma.createFelaElement)(_.Text, {
    variant: "bodyBold",
    color: isBuyWin ? 'text.positive' : 'text.negative'
  }, isBuyWin ? buyLabel : sellLabel) : (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    color: "text.1"
  }, "--")), indicators === null || indicators === void 0 ? void 0 : indicators.map(({
    value,
    label
  }) => (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    key: label,
    margin: [0, 'xlarge', 0, 0],
    css: css.indicator
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: "text.2"
  }, label), (0, _pragma.createFelaElement)(_.Text, {
    variant: "body",
    color: "text.1"
  }, value)))), percent && (0, _pragma.createFelaElement)(_.Progress, {
    variant: "buySell",
    value: percent
  }), (0, _pragma.createFelaElement)(_.View, {
    flex: true,
    flexDirection: "row",
    justifyContent: "space-between",
    margin: ['medium', 0, 0, 0]
  }, (0, _pragma.createFelaElement)(_.View, null, (0, _pragma.createFelaElement)(_.Text, {
    variant: "metaBold",
    color: "text.1"
  }, buyValue !== null && buyValue !== void 0 ? buyValue : '--'), (0, _pragma.createFelaElement)(_.View, {
    margin: [0, 0, 0, 'xsmall']
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: "text.2"
  }, buyLabel))), (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: "text.2"
  }, description), (0, _pragma.createFelaElement)(_.View, null, (0, _pragma.createFelaElement)(_.View, {
    margin: [0, 'xsmall', 0, 0]
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: "text.2"
  }, sellLabel)), (0, _pragma.createFelaElement)(_.Text, {
    variant: "metaBold",
    color: "text.1"
  }, sellValue !== null && sellValue !== void 0 ? sellValue : '--')))));
});
RatingChart.displayName = 'RatingChart';
var _default = RatingChart;
exports.default = _default;
//# sourceMappingURL=RatingChart.js.map